/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PayoutSource = {
    FAVRIT: 'FAVRIT',
    ADYEN: 'ADYEN',
    UNKNOWN: 'UNKNOWN'
} as const;
export type PayoutSource = typeof PayoutSource[keyof typeof PayoutSource];


export function instanceOfPayoutSource(value: any): boolean {
    for (const key in PayoutSource) {
        if (Object.prototype.hasOwnProperty.call(PayoutSource, key)) {
            if (PayoutSource[key as keyof typeof PayoutSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PayoutSourceFromJSON(json: any): PayoutSource {
    return PayoutSourceFromJSONTyped(json, false);
}

export function PayoutSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutSource {
    return json as PayoutSource;
}

export function PayoutSourceToJSON(value?: PayoutSource | null): any {
    return value as any;
}

export function PayoutSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): PayoutSource {
    return value as PayoutSource;
}

